import { Card, CardContent, CardDescription, CardHeader } from "@/components/kit";
import SignInForm from "../ui/SignInForm";

export function LoginPage() {
  return (
    <Card className="brand-card w-full gap-0 py-0">
      <CardHeader className="gap-3 border-b border-secondary/15 px-6 pt-8 pb-6">
        <div className="flex flex-col gap-1">
          <h1 className="font-display text-2xl text-foreground">ເຂົ້າລະບົບ</h1>
          <div className="h-0.5 w-12 rounded-full bg-secondary/70" aria-hidden />
        </div>
        <CardDescription className="text-pretty leading-relaxed">
          ໃສ່ອີເມວ ແລະ ລະຫັດຜ່ານຂ້າງລຸ່ມນີ້ ເພື່ອເຂົ້າໃຊ້ບັນຊີຂອງທ່ານ
        </CardDescription>
      </CardHeader>
      <CardContent className="px-6 py-6">
        <SignInForm />
      </CardContent>
    </Card>
  );
}
